<template>
  <el-breadcrumb class="pluginRow">
    <el-breadcrumb-item
      v-for="(item, index) in navs"
      :key="index"
    >
      <a
        v-if="index!==navs.length-1"
        @click="item.onClick?item.onClick():$router.back()"
      >{{ item.title }}</a>
      <template v-else>
        {{ item.title }}
      </template>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'BreadcrumbBack',
  props: {
    navs: {
      default: () => [
        {
          title: '',
          onClick: () => { }
        }
      ],
      type: Array
    }
  }
}
</script>

<style scoped>
</style>
